import React, { useState } from 'react';
import MyAccount from './MyAccount';
import Contacts from './Contacts';

export default function Sprava({ userId, userRole, isDarkMode }) {
  const [activeTab, setActiveTab] = useState('account');

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-gray-100'}`}>
      {/* Tab bar - velké přepínač tlačítka */}
      <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border-b shadow-sm`}>
        <div className="max-w-[1600px] mx-auto px-4 py-3 flex gap-3">
          <button
            onClick={() => setActiveTab('account')}
            className={`flex-1 sm:flex-none flex items-center justify-center gap-2 px-6 py-3 rounded-xl text-base font-semibold transition ${
              activeTab === 'account'
                ? 'bg-blue-600 text-white shadow'
                : isDarkMode
                  ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            👤 Můj účet
          </button>
          <button
            onClick={() => setActiveTab('contacts')}
            className={`flex-1 sm:flex-none flex items-center justify-center gap-2 px-6 py-3 rounded-xl text-base font-semibold transition ${
              activeTab === 'contacts'
                ? 'bg-blue-600 text-white shadow'
                : isDarkMode
                  ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            📞 Kontakty
          </button>
        </div>
      </div>

      {/* Tab content */}
      <div>
        {activeTab === 'account' && (
          <MyAccount userId={userId} isDarkMode={isDarkMode} />
        )}
        {activeTab === 'contacts' && (
          <Contacts userRole={userRole} currentUserId={userId} isDarkMode={isDarkMode} />
        )}
      </div>
    </div>
  );
}
